module.exports = __webpack_public_path__ + "static/media/mission-ranch.e7238209.jpg";